import React from 'react';
import Chevron from './Chevron';

// Catch-all card for orphan journeys. Distinct dashed style; hides itself when
// empty. Sits at the TOP of the list. See design-handoff.md C.1 / C.4.

export interface UnsortedJourneysCardProps {
  count: number;
  onOpen: () => void;
}

const UnsortedJourneysCard: React.FC<UnsortedJourneysCardProps> = ({ count, onOpen }) => {
  if (count <= 0) return null;
  return (
    <button
      onClick={onOpen}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        textAlign: 'left',
        background: '#ffffff',
        border: '1.5px dashed rgba(20,40,30,0.18)',
        borderRadius: 22,
        padding: '16px',
        cursor: 'pointer',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 44,
          height: 44,
          borderRadius: 14,
          background: '#f1f5f3',
          fontSize: 20,
          flexShrink: 0,
        }}
        aria-hidden
      >
        🗂️
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, color: '#16241d', fontSize: 15 }}>Unsorted journeys</div>
        <div style={{ color: '#6c7872', fontSize: 13 }}>
          {count} {count === 1 ? 'journey' : 'journeys'} not yet filed under a trip
        </div>
      </div>
      <Chevron />
    </button>
  );
};

export default UnsortedJourneysCard;
